
export const setEmailBodyExpociencias = (props, urlConfirma, urlResumen) => {

    console.log(props);
    const styles = {
        p:{border:'1px solid gray', width:'380px', backgroundColor:'#ddd'},
        div:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#ddd'},
        divWhite:{textAlign:'center', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#fff'},
        divWhiteLeft:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#fff'},
        divWhiteLeftNoBorder:{width:'380px', padding:'10px 20px', margin:'10px 0',backgroundColor:'#fff'},
        li:{padding:'6px 0'},
    }

    let participaValue = '';
    switch (props.participacion) {
        case 'individual':
            participaValue = 
            <p>Participación: <strong>individual</strong><br /><br />
                Nombre: {props.est1NombreCompleto}<br />
                Correo: {props.est1Correo}<br />
                Telefono: {props.est1Telefono}<br />
                Edad: {props.est1Edad}<br />
                Sexo: {props.est1Sexo}<br />
                Talla de Camiseta: {props.est1TallaCamiseta}
            </p>;
            break;
        case 'equipo2':
            participaValue = 
            <p>Participación: <strong>en equipo de 2 participantes</strong><br /><br />
                Nombre: {props.est1NombreCompleto}<br />
                Correo: {props.est1Correo}<br />
                Telefono: {props.est1Telefono}<br />
                Edad: {props.est1Edad}<br />
                Sexo: {props.est1Sexo}<br />
                Talla de Camiseta: {props.est1TallaCamiseta}<br />
                <br />
                Nombre: {props.est2NombreCompleto}<br />
                Correo: {props.est2Correo}<br />
                Telefono: {props.est2Telefono}<br />
                Edad: {props.est2Edad}<br />
                Sexo: {props.est2Sexo}<br />
                Talla de Camiseta: {props.est2TallaCamiseta}
            </p>;
            break;
        case 'equipo3':
            participaValue = 
            <p>Participación: <strong>en equipo de 3 participantes</strong><br /><br />
                Nombre: {props.est1NombreCompleto}<br />
                Correo: {props.est1Correo}<br />
                Telefono: {props.est1Telefono}<br />
                Edad: {props.est1Edad}<br />
                Sexo: {props.est1Sexo}<br />
                Talla de Camiseta: {props.est1TallaCamiseta}<br />
                <br />
                Nombre: {props.est2NombreCompleto}<br />
                Correo: {props.est2Correo}<br />
                Telefono: {props.est2Telefono}<br />
                Edad: {props.est2Edad}<br />
                Sexo: {props.est2Sexo}<br />
                Talla de Camiseta: {props.est2TallaCamiseta}<br />
                <br />
                Nombre: {props.est3NombreCompleto}<br />
                Correo: {props.est3Correo}<br />
                Telefono: {props.est3Telefono}<br />
                Edad: {props.est3Edad}<br />
                Sexo: {props.est3Sexo}<br />
                Talla de Camiseta: {props.est3TallaCamiseta}
            </p>;
            break;
    
        default:
            break;
    }

    let facturaValue = '';
    if (props.requiereFactura) {
        facturaValue = 
        <p>Facturación: <strong>SI requiere factura</strong><br /><br />
            Nombre a facturar: {props.factNombre}<br />
            RFC: {props.factRfc}<br />
            C.P.: {props.factCP}<br />
            Uso CFDI (clave): {props.factUsoCFDI}<br />
            Regimen fiscal (clave): {props.factRegimenFiscal}<br />
        </p>;
    } else {
        facturaValue = <p>Facturación: <strong>NO requiere factura</strong></p>;
    }


    return (
        <>
            <div style={styles.divWhite}>
                <img src="https://eventos.cibnor.mx/registro/expociencias/img/logo_expociencias2022.png" alt="logo" width={380}></img>
            </div>
            <div style={styles.divWhite}>
                <p>¡Su prerregistro ha sido completado con éxito!</p>
                <h2>Numero de referencia: <br />{props.refBancaria}</h2>
            </div>
            <div style={styles.div}>
                <h4>Asesoría</h4>
                <p>
                    Nombre completo: {props.asesorNombres} {props.asesorApellidos}<br />
                    Correo: {props.asesorCorreo}<br />
                    Telefono: {props.asesorTelefono}<br />
                    Talla de camiseta: {props.asesorTallaCamiseta}<br />
                </p>
            </div>
            <div style={styles.div}>
                <h4>Institución</h4>
                <p>
                    Nombre: {props.instNombre}<br />
                    Domicilio: {props.instDomicilio}<br />
                    Municipio: {props.instMunicipio}<br />
                </p>
            </div>
            <div style={styles.div}>
                <h4>Proyecto</h4>
                <p>
                    Título: {props.proyTitulo}<br />
                    <a href={urlResumen}>Enlace al resumen</a>
                </p>
            </div>
            <div style={styles.div}>
                {participaValue}
            </div>
            <div style={styles.div}>
                {facturaValue}
            </div>
            <div style={styles.div}>
                {(props.comentarios !== '') ? <p><strong>Comentarios adicionales</strong><br /> {props.comentarios}</p>
                : <p><strong>Comentarios adicionales</strong><br /><i>[ Ninguno ]</i></p>}
            </div>
            <div style={styles.divWhiteLeft}>
                <h3>Indicaciones para completar el registro</h3>
                <ol>
                    <li style={styles.li}>Consultar el monto correspondiente al tipo de participación.<br/>
                    <a href={"https://www.cibnor.gob.mx/eventos-cibnor/3180-expociencias-2022#costos"}><strong>Enlace para ver las cuotas de recuperación.</strong></a>
                    </li> 
                    <li style={styles.li}>Pagar en sucursal bancaria la cuota consultada.<br/>
                    <p>
                        Banco: <strong>BBVA</strong><br />
                        Convenio CIE: <strong>1 2 5 6 2 5</strong> <br />
                        Referencia: <strong>{props.refBancaria}</strong><br />
                    </p>
                    </li>
                    <li style={styles.li}>Subir al sistema su comprobante de deposito.<br/>
                    <h3><a href={urlConfirma}>Enlace para subir su comprobante.</a></h3>
                    </li>
                </ol>
                <p>
                Después de realizar el pago cuenta con un máximo de 5 días hábiles para completar su registro, en caso contrario este será anulado.
                </p>
            </div>
            <div style={styles.divWhiteLeft}>
                <h4>Notas adicionales</h4>
                <ul>
                    <li>En caso de solicitar factura, ésta se enviará al correo que se ingresó.</li>
                    <li>Se realizará la facturación salvo buen cobro.</li>
                </ul>
            </div>
            <div style={styles.divWhiteLeftNoBorder}>
               <strong><i>Atentamente,<br/>Comité organizador</i></strong>
            </div>
        </>
        
    );
};
